module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.e6cd02ed.png";